export default __webpack_public_path__ + "static/media/ER-GK60-S421-2.ae266887.jpg";